// クラシック版の起動（段階 C の2 の 7d。2026-10-26 に chibi.js の init・initMode・firstMessage・checkFirst と、画面ファイル gen1a.js・gen1b.js・gen2.js の init・initMode、
// gen2a.js・storm.js・portrait.js の firstMessage から描き直した。動きは前と同じ）。
// init: 領域の大きさ → 読み込み中 → キャラの SVG の入れ物・メニューの SVG → キャラの上のクリック → 倍率（scale）→ 右の列 → 背景のレイヤー → スクロールバー（PC）→ キャラのデータ →
// setCategory → 初めのキャラ（loadDefault）→ initMode →（エンジンのまま・第2世代は）はじめの確認（checkFirst → firstMessage）。
// 系統（SCREEN）ごとの違い:
//   エンジンのまま: スマホは下からパーツ・カテゴリ・グループ・色・うすさ・拡大の欄を積む、真ん中のタップは何もしない、背景のレイヤーに柄・回転・うすさの値も
//   第1世代 a・第2世代: スマホはカテゴリ 8%（50px まで）・パーツ 22%（150px まで）、キャラの倍率 0.95・0.89、色のボタンの大きさは色の欄の幅、
//     真ん中のタップは拡大して見る（第2世代は CENTER_TAP: "name" で名前）、第2世代はグラデーションのバーの高さの上限・背景に柄の値・線の太さ・はじめの確認
//   第1世代 b: スマホのパーツの段は縦長の画面だけ 2 段（そのときメインは 75%）、SCALE_SMALL、真ん中のタップは CENTER_TAP（既定 "reverse" で全体の反転、"zoom" で拡大して見る）、
//     スクロールを止める欄に柄（PATTERN_IN_COLOR）、背景の柄の値は MODE_PATTERN、線の太さ
// initMode: カテゴリの欄の位置・色のボタンを押した形・パーツの欄・はじめのカテゴリ・拡大して見るの初め
// firstMessage: エンジンのまま（旧処理 legacyInit・うすさ・回転の付け直し・はじめのカテゴリ）／第2世代 a（吹き出し 1 つ）／storm（名前が無ければ名前のダイアログ・インナー・吹き出し 2 つ）／
//   似顔絵（似顔絵の旧処理 legacyInitPortrait・うすさ・回転の付け直し・はじめのカテゴリ）
// 大きさ・CSS・クリックは jq.ts（jQuery と同じ決まり、2026-10-26 の 7g-2）。スクロールバーは scrollbar.ts（fx.scrollbarX・scrollbarY）。クリックの取り出しは fx.d3ClickCall
import { chibi, common } from './engine.js';
import { screen } from './colors.js';
import * as fx from './fx.js';
import { S } from './sel.js';
import * as jq from './jq.js';

type Engine = Record<string, any>;
const E = (): Engine => chibi() as unknown as Engine;
const C = (): Record<string, any> => common() as unknown as Record<string, any>;
const charat = (): Record<string, any> => (window as unknown as { charat: Record<string, any> }).charat;
const tt = (): Record<string, string> => (typeof _t !== 'undefined' && _t ? _t : {});

/** 欄のスクロールでページが動かないように止める */
function lockScroll(sels: string[]): void {
  jq.on(sels.join(','), 'scroll mousewheel', (event: Event) => {
    event.preventDefault();
  });
}
/** キャラの SVG の入れ物・メニューの SVG・メニューの外を押したら閉じる */
function makeSvgs(msize: number): void {
  const e = E();
  e.svgMake = C().getD3SVGWidhG(e.DIV_F_MAKE, e.SVG_SAVE, e.SVG_BGSAVE, e.SVG_MAKE, e.SVG_TEXT, e.SVG_BG, e.SVG_CLIP, jq.width(e.DIV_F_MAKE), jq.height(e.DIV_F_MAKE), msize, msize, e.SCALE_MAKE);
  e.svgBg = S.select('#' + e.SVG_BG);
  e.svgMenu = C().getD3SVG(e.DIV_F_MENU, e.SVG_MENU);
  e.svgMakeMenu = C().getD3SVG(e.DIV_F_MAKEMENU, e.SVG_MAKEMENU);
  e.svgEditMenu = C().getD3SVG(e.DIV_F_EDITMENU, e.SVG_EDITMENU);
  jq.on(e.DIV_F_EDITMENU, 'click', () => {
    E().btnMenuClose.CLICK();
  });
}
/** キャラの上のクリック: 真ん中は onCenter（無ければ何もしない）、台詞のメーカーは上の段の真ん中で名前（台詞）の入力 */
function centerTap(onCenter: (() => void) | null): void {
  const e = E();
  jq.on(e.DIV_F_MAKEMENU, 'click', function (this: Element, ev: MouseEvent) {
    const en = E();
    const clientRect = this.getBoundingClientRect();
    const w = jq.width(en.DIV_F_MAKEMENU);
    const h = jq.height(en.DIV_F_MAKEMENU);
    const px = ev.clientX - clientRect.left;
    const py = ev.clientY - clientRect.top;
    if (en.execMode == en.MODE_VIEW) return;
    if (w / 3 <= px && px <= (w * 2) / 3 && h / 3 <= py && py <= (h * 2) / 3) {
      if (onCenter) onCenter();
    } else if (en.MODE_TEXT && en.isViewText) {
      if (w / 3 <= px && px <= (w * 2) / 3 && 0 <= py && py <= h / 3) en.btnMenuName.EXEC();
    }
  });
}
/** 倍率（画像の座標 → 画面の座標）。colorFromScroll: 色のボタンの大きさを色の欄の幅にする（系統のある画面）。gradMobileMax: スマホのグラデーションのバーの高さの上限 360 */
function makeScales(msize: number, colorFromScroll: boolean, gradMobileMax: boolean): void {
  const e = E(), c = C();
  e.scMake = c.getScale(e.SIZE_CHARAT_IMAGE, msize * e.SCALE_MAKE, e.SIZE_CHARAT_IMAGE, msize * e.SCALE_MAKE);
  e.scCategory = c.getScale(e.SIZE_CATEGORY_ICON, jq.height(e.DIV_F_CATEGORY), e.SIZE_CATEGORY_ICON, jq.height(e.DIV_F_CATEGORY));
  e.scParts = c.getScale(e.SIZE_PARTS_ICON, jq.height(e.DIV_F_PARTS) / e.SIZE_PARTS_ROW, e.SIZE_PARTS_ICON, jq.height(e.DIV_F_PARTS) / e.SIZE_PARTS_ROW);
  if (colorFromScroll) {
    e.SIZE_COLOR_ICON_W = jq.width(e.DIV_F_COLOR_SC);
    e.SIZE_COLOR_ICON_H = jq.width(e.DIV_F_COLOR_SC);
  }
  e.scColor = c.getScale(e.SIZE_COLOR_ICON_W, e.SIZE_COLOR_ICON_W, e.SIZE_COLOR_ICON_H, e.SIZE_COLOR_ICON_H);
  e.scGrad = c.getScale(30 + 60, (jq.width(e.DIV_F_GRAD) * 9) / 10, 480, gradMobileMax && e.isMobile ? Math.min(360, (jq.height(e.DIV_F_GRAD) * 7) / 10) : (jq.height(e.DIV_F_GRAD) * 7) / 10);
}
/** 背景のレイヤー g#lcart_bg と初めの値（full: 柄・回転・うすさの値も＝エンジンのまま、ptn: 柄の値まで＝第2世代） */
function makeBgLayer(full: boolean, ptn: boolean): void {
  const e = E();
  jq.setCss(e.DIV_F_MAIN, 'background-image', 'none');
  if (e.COLOR_BG != '') jq.setCss(e.DIV_F_MAIN, 'background-color', e.COLOR_BG);
  const scx = e.scMake.x(e.SIZE_CHARAT_BGIMAGE) / e.SIZE_CHARAT_BGIMAGE, scy = e.scMake.y(e.SIZE_CHARAT_BGIMAGE) / e.SIZE_CHARAT_BGIMAGE;
  let g = e.svgBg
    .append('g')
    .attr('id', e.ATTR_LAYER + e.PARTS_BG)
    .attr('paramParts', '')
    .attr('paramTx', 0)
    .attr('paramTy', 0)
    .attr('paramScx', scx)
    .attr('paramScy', scy)
    .attr('paramRev', 0)
    .attr('paramScale', 1)
    .attr('paramCol', '')
    .attr('paramColFrom', '')
    .attr('paramColTo', '')
    .attr('paramColLFrom', '')
    .attr('paramColLTo', '')
    .attr('paramColRFrom', '')
    .attr('paramColRTo', '');
  if (full || ptn) g = g.attr('paramPtn', '').attr('paramPrev', 0).attr('paramPtnMode', 0);
  if (full) g = g.attr('paramRotate', 0).attr('paramOpacity', 1);
  g.attr('transform', () => 'translate(0, 0), scale(' + scx + ',' + scy + ')');
}
/** カテゴリとパーツの欄を横のスクロールバーに（PC） */
function makeScrollbars(): void {
  const e = E();
  if (e.isMobile) return;
  // カテゴリ（mCSB_1）・パーツ（mCSB_2）の順に作る（番号は作った順。parts.ts が #mCSB_2_container を使う）
  fx.scrollbarX(e.DIV_F_CATEGORY_SC);
  fx.scrollbarX(e.DIV_F_PARTS_SC);
}
/** キャラのデータを読み（ブラウザに覚えていればそれ、無ければ getcategory.php）、カテゴリ → 初めのキャラ → initMode →（withCheck なら）はじめの確認 */
function loadCategory(withCheck: boolean): void {
  const e = E();
  e.loadDB(e.isUseCache, e.CACHE_KEY_CHARA, (charaData: string | null) => {
    const en = E();
    const start = (data: unknown, text: string | null): void => {
      en.setCategory(data, en.scCategory.x(en.SIZE_CATEGORY_ICON), en.scCategory.y(en.SIZE_CATEGORY_ICON), 1, () => {
        E().loadDefault();
        E().initMode();
        if (text != null) E().saveDB(E().CACHE_KEY_CHARA, text);
        C().setNowLoading(false);
        if (withCheck) E().checkFirst();
      });
    };
    if (charaData != null) {
      start(JSON.parse(charaData), null);
    } else {
      C()
        .fetchCategoryText(en.URI_GETCATEGORY, en.isCompress)
        .then((text: string | null) => {
          if (text != null && text != '') start(JSON.parse(text), text);
          else C().setNowLoading(false); // 読めなかったか、中身が空
        });
    }
  });
}

/**
 * 作る画面の入口（各メーカーの create/index.php が呼ぶ）。aMode: "edit" か閲覧（昔の共有のリンク。initMode で編集にする）。aShareCode・aShareKey は前の名残
 */
export function init(aUid: string, aMode: string, aShareCode: string, aShareKey: string): void {
  const e = E(), scr = screen();
  e.loadReload(60);
  e.loadUserID(aUid);
  charat().ProhibitPIPO(e.isMobile);
  e.execMode = aMode == 'edit' ? e.MODE_EDIT : e.MODE_VIEW;
  e.shareCode = aShareCode;
  e.shareKey = aShareKey;
  if (scr === 'new') initNew();
  else initGen(scr);
}

/** エンジンのまま（dressup2・genesis2・kawaii・kawaii2・似顔絵） */
function initNew(): void {
  const e = E();
  lockScroll([e.DIV_F_COLOR_SC, e.DIV_F_CATEGORY_SC, e.DIV_F_PARTS_SC]);
  const H = (s: string): number => jq.height(s);
  if (e.isMobile) {
    // 下から パーツ → カテゴリ → グループ → 色 → うすさ → 拡大 の順に積む（screen.innerWidth は無いので幅は付かない。前のまま）
    jq.setHeight(e.DIV_F_ROOT, window.innerHeight);
    jq.setWidth(e.DIV_F_ROOT, (screen as unknown as { innerWidth: unknown }).innerWidth);
    jq.setHeight(e.DIV_F_CONTENTS, H(e.DIV_F_ROOT) - H(e.DIV_F_ADS_MB));
    jq.setHeight(e.DIV_F_CATEGORY_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.1, 45));
    jq.setHeight(e.DIV_F_MAIN, H(e.DIV_F_CONTENTS));
    jq.setHeight(e.DIV_F_PARTS_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.25, 150));
    jq.setHeight(e.DIV_F_SUBMENU, Math.min(H(e.DIV_F_CONTENTS) * 0.25, 150));
    jq.setCss(e.DIV_F_MAKE_RSTBG, 'top', jq.outerHeight(e.DIV_F_MAKE_RESULT));
    jq.setCss(e.DIV_F_GROUP_SC, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_PARTS_SC) - H(e.DIV_F_CATEGORY_SC) - 30);
    jq.setCss(e.DIV_F_COLORAREA, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_PARTS_SC) - H(e.DIV_F_CATEGORY_SC) - H(e.DIV_F_GROUP_SC) - 60);
    jq.setCss(e.DIV_F_PATTERNAREA, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_PARTS_SC) - H(e.DIV_F_CATEGORY_SC) - H(e.DIV_F_GROUP_SC) - 60);
    jq.setCss(e.DIV_F_OPACITY, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_PARTS_SC) - H(e.DIV_F_CATEGORY_SC) - H(e.DIV_F_GROUP_SC) - H(e.DIV_F_COLORAREA));
    jq.setCss(e.DIV_F_ZOOM, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_PARTS_SC) - H(e.DIV_F_CATEGORY_SC) - H(e.DIV_F_GROUP_SC) - H(e.DIV_F_COLORAREA) - H(e.DIV_F_OPACITY) - 20);
  } else {
    // 注意: パーツの欄の高さを 0.32 で付けた直後に 0.25 で付け直している（前のまま）
    jq.setHeight(e.DIV_F_PARTS_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.32, 150));
    jq.setHeight(e.DIV_F_CATEGORY_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.1, 45));
    jq.setHeight(e.DIV_F_MAIN, H(e.DIV_F_CONTENTS));
    jq.setHeight(e.DIV_F_PARTS_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.25, 150));
    jq.setHeight(e.DIV_F_SUBMENU, Math.min(H(e.DIV_F_CONTENTS) * 0.25, 150));
    jq.setCss(e.DIV_F_GROUP_SC, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_PARTS_SC) - H(e.DIV_F_CATEGORY_SC) - 40);
  }
  C().setNowLoading(true, e.DIV_F_CONTENTS);
  // 描く所（縦横の短いほうに合わせた正方形）
  const msize = Math.min(jq.width(e.DIV_F_MAKE), jq.height(e.DIV_F_MAKE));
  e.SCALE_MAKE = e.isMobile ? 1 : 1;
  e.SCALE_SAVE = e.isMobile ? 1 : 1.083;
  makeSvgs(msize);
  centerTap(null);
  makeScales(msize, false, true);
  e.setNewMakeManu();
  makeBgLayer(true, false);
  if (e.STROKE_WIDTH) e.svgBg.select('#' + e.ATTR_LAYER + e.PARTS_BG).attr('paramSW', '');
  makeScrollbars();
  loadCategory(true);
}

/** 系統のある画面（第1世代 a・b、第2世代） */
function initGen(scr: string): void {
  const e = E();
  const gen1b = scr === 'gen1b', gen2 = scr === 'gen2';
  const H = (s: string): number => jq.height(s);
  lockScroll(gen1b && e.config('PATTERN_IN_COLOR', false) ? [e.DIV_F_COLOR_SC, e.DIV_F_PATTERN_SC, e.DIV_F_CATEGORY_SC, e.DIV_F_PARTS_SC] : [e.DIV_F_COLOR_SC, e.DIV_F_CATEGORY_SC, e.DIV_F_PARTS_SC]);
  if (e.isMobile) {
    if (gen1b) {
      // 第1世代 b: パーツの段は縦長の画面（高さ ÷ 幅 > 1.75、幅 350 より大きい）だけ 2 段（そのときメインは 75%・パーツの欄は 25%）
      e.SIZE_PARTS_ROW = 1;
      jq.setHeight(e.DIV_F_ROOT, window.innerHeight);
      jq.setWidth(e.DIV_F_ROOT, (screen as unknown as { innerWidth: unknown }).innerWidth);
      if (H(e.DIV_F_ROOT) / jq.width(e.DIV_F_ROOT) > 1.75 && jq.width(e.DIV_F_ROOT) > 350) {
        e.SIZE_PARTS_ROW = 2;
        jq.setHeight('#chaDivMain', '75%');
        jq.setHeight('#chaDivPartsScroll', '25%');
      }
      jq.setHeight(e.DIV_F_CONTENTS, H(e.DIV_F_ROOT) - H(e.DIV_F_ADS_MB));
      jq.setCss(e.DIV_F_MAKE_RSTBG, 'top', jq.outerHeight(e.DIV_F_MAKE_RESULT));
    } else {
      jq.setHeight(e.DIV_F_ROOT, window.innerHeight);
      jq.setWidth(e.DIV_F_ROOT, (screen as unknown as { innerWidth: unknown }).innerWidth);
      e.SIZE_PARTS_ROW = 2;
      jq.setHeight(e.DIV_F_CONTENTS, H(e.DIV_F_ROOT) - H(e.DIV_F_ADS_MB));
      jq.setHeight(e.DIV_F_CATEGORY_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.08, 50));
      jq.setHeight(e.DIV_F_MAIN, H(e.DIV_F_CONTENTS) - H(e.DIV_F_CATEGORY_SC));
      jq.setHeight(e.DIV_F_PARTS_SC, Math.min(H(e.DIV_F_CONTENTS) * 0.22, 150));
      jq.setCss(e.DIV_F_MAKE_RSTBG, 'top', jq.outerHeight(e.DIV_F_MAKE_RESULT));
    }
  } else {
    e.SIZE_PARTS_ROW = 2;
  }
  C().setNowLoading(true, e.DIV_F_CONTENTS);
  const msize = Math.min(jq.width(e.DIV_F_MAKE), jq.height(e.DIV_F_MAKE));
  if (gen1b && e.config('SCALE_SMALL', false)) {
    e.SCALE_MAKE = e.isMobile ? 0.95 * 1 : 0.89 * 0.97;
    e.SCALE_SAVE = e.isMobile ? 1 * 0.955 : 1.083 * 0.97;
  } else {
    e.SCALE_MAKE = e.isMobile ? 0.95 : 0.89;
    e.SCALE_SAVE = e.isMobile ? 1 : 1.083;
  }
  makeSvgs(msize);
  // 真ん中のタップ: 第1世代 a は拡大して見る、第2世代は CENTER_TAP（"name" で名前、ほかは拡大）、第1世代 b は CENTER_TAP（"zoom" で拡大、ほかは反転）
  centerTap(() => {
    const en = E();
    if (gen2 && en.config('CENTER_TAP', 'zoom') == 'name') en.btnMenuName.EXEC();
    else if (gen1b && en.config('CENTER_TAP', 'reverse') != 'zoom') en.btnSubReverse.EXEC();
    else en.btnSubZoom.EXEC();
  });
  makeScales(msize, true, gen2);
  e.setNewMakeManu();
  makeBgLayer(false, gen2);
  if (gen1b && e.config('MODE_PATTERN', true)) e.svgBg.select('#' + e.ATTR_LAYER + e.PARTS_BG).attr('paramPtn', '').attr('paramPrev', 0).attr('paramPtnMode', 0);
  if ((gen1b || gen2) && e.config('STROKE_WIDTH', false)) e.svgBg.select('#' + e.ATTR_LAYER + e.PARTS_BG).attr('paramSW', '');
  makeScrollbars();
  loadCategory(gen2);
}

/** カテゴリを読み込んだあと: 初めのメニューの形にして編集にする（昔の共有のリンクで開いても編集） */
export function initMode(): void {
  const e = E(), scr = screen();
  const H = (s: string): number => jq.height(s);
  if (scr === 'new') {
    jq.setCss(e.DIV_F_CATEGORY_SC, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_CATEGORY_SC) - H(e.DIV_F_PARTS_SC));
    fx.d3ClickCall('#' + e.btnEditColor.ID + 'click', { BTN: e.btnEditColor });
  } else {
    jq.setCss(e.DIV_F_CATEGORY_SC, 'top', H(e.DIV_F_MAIN) - H(e.DIV_F_CATEGORY_SC));
    fx.d3ClickCall('#' + e.btnEditColor.ID + 'click', { BTN: e.btnEditColor });
    if (scr === 'gen1b') fx.d3ClickCall('#' + e.btnEditParts.ID + 'click', { BTN: e.btnEditParts });
    else e.btnEditParts.ON_PARTS();
    if (scr !== 'gen2' || e.config('INIT_CLICK_FIRST_CATEGORY', true)) fx.d3ClickCall('#chibiCategoryBtn0');
  }
  E().btnSubZoom.INIT();
  E().execMode = E().MODE_EDIT;
}

/** はじめの確認: CHARAT のどこでも規約への同意が無く、編集なら確認の画面（START で同意を覚えて作り始め、CANCEL でサイトのトップへ）。2 回目からはすぐ作り始め */
export function checkFirst(): void {
  const e = E();
  if (e.isFirst() && e.execMode != e.MODE_VIEW) {
    C().setFirstCheck(
      e.DIV_F_CONTENTS,
      () => {
        E().setFirst('true');
        E().firstMessage();
      },
      () => {
        window.location.href = '../../';
      },
    );
  } else {
    e.firstMessage();
  }
}

/** 作り始めの仕上げ（系統・メーカーごと） */
export function firstMessage(): void {
  const e = E(), scr = screen();
  const w = window as unknown as Record<string, unknown>;
  if (scr === 'gen2') {
    if (e.config('FIRST_MESSAGE', 'tip') === 'storm') {
      // storm: 名前が無ければ名前のダイアログ、インナーの表示を整え、吹き出しを 2 つ（step3 は代入だけ。c は前と同じくページ全体の変数）
      const nameText = document.querySelector('#' + e.SVG_TEXT + 'name');
      let nameTextData = nameText ? nameText.getAttribute('textdata') : null;
      if (!nameTextData && e.execMode !== e.MODE_VIEW) e.btnMenuName.EXEC();
      C().underHidden();
      if (!e.isMobile) C().finishModal();
      const step1Message = tt().step1 ? tt().step1 : 'Choose a category for the parts.';
      nameTextData = tt().step2 ? tt().step2 : 'You can select any color you like.';
      w.c = tt().step3 ? tt().step3 : 'You can move, scale, and flip parts.';
      C().viewTooltip('CATEGORY', true, '#' + e.SVG_TEXT, 'top', step1Message, [600, 300], true);
      C().viewTooltip('EXCOL', true, e.DIV_F_PICKCOLOR, 'right', nameTextData, [600, 300], true);
    } else {
      // 第2世代 a（boys・origin・genesis・jakigan）: 吹き出しを 1 つ
      C().viewTooltip('CATEGORY', true, '#' + e.SVG_TEXT, 'top', tt().category_select ? tt().category_select : 'Select a category to edit.', [600, 300], true);
    }
    return;
  }
  // エンジンのまま・似顔絵: 前任者のメーカー専用の旧処理（charat.legacy.js）・うすさ・回転の付け直し・はじめのカテゴリとパーツの欄
  if (e.config('FIRST_MESSAGE', 'tip') === 'portrait') C().legacyInitPortrait();
  else C().legacyInit();
  C().toggleOpacityDisplay();
  setTimeout(() => {
    C().rotateAllLayers();
  }, 100);
  fx.d3ClickCall('#chibiCategoryBtn0');
  e.btnEditParts.ON_PARTS();
  if (!e.isMobile) C().finishModal();
  // 操作説明の文言（代入だけで使っていない。c は前と同じくページ全体の変数）
  w.c = tt().step3 || 'You can move, scale, and flip parts.';
}
